<script lang="ts" setup>
import type Decimal from "decimal.js"
import type { LimitedSubscriptionFeaturesModel } from "~/utils/generated/api"

const props = defineProps<{
	id: string
	title: string
	description: string
	price: string
	originalPrice: Decimal
	bold: boolean
	timeDuration: string
	features: LimitedSubscriptionFeaturesModel[]
}>()

const emit = defineEmits<{
	go: [id: string]
}>()

const boldWrapperClass = computed(() => {
	return {
		"relative z-1 border-3 xl:scale-105 border-website-primary": props.bold,
		"border-2 border-foreground": !props.bold,
	}
})

const btnClass = computed(() => {
	return {
		"bg-website-primary hover:bg-website-primary/50": props.bold,
		"bg-foreground hover:bg-foreground/50": !props.bold,
	}
})
</script>

<template>
	<div
		:class="boldWrapperClass"
		class="max-w-[360px] rounded-xl border-solid bg-background p-5">
		<span
			v-if="bold"
			class="absolute inset-x-0 top-[-15px] mx-a w-fit border-2 border-website-primary rounded-full border-solid bg-background px-3 py-1 text-xs">
			پیشنهادی
		</span>

		<div class="mb-6 border-b-2 border-foreground/15 pb-6">
			<h3 class="text-xl font-bold">
				{{ title }}
			</h3>

			<p class="mt-2 text-sm text-foreground/80">
				{{ description }}
			</p>
		</div>

		<div>
			<div class="flex items-center justify-between">
				<span class="text-xl">{{ price }}</span>

				<span class="float-end text-xs text-foreground/80">{{ timeDuration }}</span>
			</div>

			<Btn
				v-if="!originalPrice.equals(0)"
				class="mt-5 h-8 w-full text-white"
				:class="btnClass"
				@click="emit('go', id)">
				برو بریم !
			</Btn>

			<NuxtLink
				v-else
				href="/app">
				<Btn
					class="mt-5 h-8 w-full text-white"
					:class="btnClass">
					برو بریم !
				</Btn>
			</NuxtLink>
		</div>

		<div class="mt-5">
			<h4 class="text-sm">
				امکانات اشتراک
			</h4>

			<ul class="list-none ps-0 text-xs">
				<li
					v-for="item in features"
					:key="item.content"
					class="mb-1 flex items-center gap-2 ps-0">
					<NuxtImg
						src="/icons/check.svg"
						loading="lazy"
						width="24"
						height="24" />
					{{ item.content }}
				</li>
			</ul>
		</div>
	</div>
</template>
